export default function LeavePage() {
  // ============================================================
  // COMMENTED OUT - Coming Soon
  // ============================================================
  // Halaman Manajemen Cuti belum diimplementasikan
  // Untuk menggunakan fitur ini, uncomment kode di bawah
  // 
  // Fitur yang tersedia:
  // - Tab "Sisa Saldo": Menampilkan sisa hari cuti per jenis cuti
  // - Tab "Ajukan": Form untuk mengajukan cuti baru
  // - Tab "Riwayat": Menampilkan riwayat pengajuan cuti
  // ============================================================

  /*
  if (loading) return <PageLoader />;

  return (
    <div className="min-h-screen bg-gray-50 pb-24">
      {/* --- Simple Header --- *//*}
      <div className="bg-primary pt-10 pb-16 px-6 rounded-b-[40px] shadow-lg relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -mr-10 -mt-10 blur-2xl"></div>
        <h1 className="text-2xl font-black text-white relative z-10 tracking-tight">Manajemen Cuti</h1>
        <p className="text-white/70 text-xs mt-1 relative z-10">Ajukan dan pantau status cuti Anda</p>
      </div>

      <div className="px-4 -mt-8 relative z-20">
        {/* --- Modern Tab Navigator --- *//*}
        <div className="flex bg-white rounded-2xl p-1.5 shadow-xl shadow-gray-200/50 mb-6 border border-gray-100">
          {TABS.map((t, i) => (
            <button
              key={i}
              onClick={() => setTab(i)}
              className={`flex-1 py-3 rounded-xl text-xs font-black uppercase tracking-widest transition-all duration-300
                ${tab === i ? "bg-primary text-white shadow-md shadow-red-200" : "text-gray-400 hover:text-gray-600"}`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* --- Content: BALANCE --- *//*}
        {tab === 0 && (
          <div className="space-y-4 animate-fade-up">
            <div className="grid grid-cols-2 gap-4">
              {balance?.balances?.map((b) => (
                <div key={b.type_id} className="bg-white rounded-[24px] p-5 border border-gray-100 shadow-sm relative overflow-hidden group">
                  <div className="absolute top-0 right-0 w-12 h-12 bg-primary/5 rounded-bl-full transition-all group-hover:scale-110"></div>
                  <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">{b.type_name}</p>
                  <p className="text-3xl font-black text-gray-800 leading-none">{b.remaining_days}</p>
                  <p className="text-[10px] font-bold text-gray-400 mt-2 italic">Sisa Hari</p>
                  <div className="mt-4 pt-3 border-t border-gray-50 flex justify-between text-[9px] font-bold uppercase tracking-wider">
                    <span className="text-red-600">Terpakai: {b.used_days}</span>
                    <span className="text-green-600">Total: {b.allocated_days}</span>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="bg-gray-900 rounded-[24px] p-5 shadow-xl">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center text-xl">🌴</div>
                <div>
                  <p className="text-[10px] font-black text-white/50 uppercase tracking-widest">Total Sisa Cuti</p>
                  <p className="text-xl font-black text-white leading-tight">{balance?.total_remaining ?? 0} Hari Tersedia</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* --- Content: APPLY FORM --- *//*}
        {tab === 1 && (
          <div className="bg-white rounded-[32px] p-6 shadow-xl shadow-gray-200/50 border border-gray-50 animate-fade-up">
            <h3 className="text-xs font-black text-red-400 uppercase tracking-[0.2em] mb-6">Detail Pengajuan</h3>
            
            <div className="space-y-5">
              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-2 block">Jenis Cuti</label>
                <select
                  value={form.leave_type_id}
                  onChange={(e) => {
                    const value = e.target.value ? parseInt(e.target.value) : "";

                    setForm({
                      ...form,
                      leave_type_id: value,
                      attachment: null,
                      attachment_name: null
                    });

                    if (fileRef.current) {
                      fileRef.current.value = "";
                    }
                  }}
                  className="w-full bg-gray-50 border-none rounded-2xl px-4 py-4 text-sm font-bold text-gray-700 focus:ring-2 focus:ring-primary/20 transition-all appearance-none"
                >
                  <option value="">Pilih Jenis</option>
                  {types.map((t) => (
                    <option key={t.id} value={t.id}>{t.name} ({t.remaining_days ?? '∞'} Hari)</option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-2 block">Dari Tanggal</label>
                  <input
                    type="date"
                    value={form.date_from}
                    onChange={(e) => setForm({...form, date_from: e.target.value})}
                    className="w-full bg-gray-50 border-none rounded-2xl px-4 py-4 text-sm font-bold text-gray-700 focus:ring-2 focus:ring-primary/20 transition-all"
                  />
                </div>
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-2 block">Sampai Tanggal</label>
                  <input
                    type="date"
                    value={form.date_to}
                    onChange={(e) => setForm({...form, date_to: e.target.value})}
                    className="w-full bg-gray-50 border-none rounded-2xl px-4 py-4 text-sm font-bold text-gray-700 focus:ring-2 focus:ring-primary/20 transition-all"
                  />
                </div>
              </div>

              <div>
                <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-2 block">Alasan Keperluan</label>
                <textarea
                  value={form.reason}
                  onChange={(e) => setForm({...form, reason: e.target.value})}
                  rows={3}
                  placeholder="Contoh: Keperluan keluarga mendesak..."
                  className="w-full bg-gray-50 border-none rounded-2xl px-4 py-4 text-xs text-gray-700 focus:ring-2 focus:ring-primary/20 transition-all resize-none"
                />
              </div>

              {selectedType?.allow_attachment && (
                <div>
                  <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-2 block">
                    Lampiran
                  </label>

                  <input
                    type="file"
                    ref={fileRef}
                    onChange={handleFile}
                    accept=".pdf,.jpg,.jpeg,.png"
                    className="w-full bg-gray-50 border-none rounded-2xl px-4 py-3 text-sm"
                  />

                  {form.attachment_name && (
                    <p className="text-xs text-gray-400 mt-2">
                      File: {form.attachment_name}
                    </p>
                  )}
                </div>
              )}

              <button
                onClick={handleSubmit}
                disabled={submitting}
                className="w-full bg-primary text-white font-black py-4 rounded-2xl shadow-lg shadow-red-200 active:scale-95 transition-all disabled:opacity-50 flex items-center justify-center gap-3 uppercase text-xs tracking-widest"
              >
                {submitting ? <LoadingSpinner size={16} color="white" /> : "Kirim Pengajuan"}
              </button>
            </div>
          </div>
        )}

        {/* --- Content: HISTORY --- *//*}
        {tab === 2 && (
          <div className="space-y-4 animate-fade-up">

            {history.length === 0 ? (
              <div className="bg-white rounded-[32px] p-12 text-center border border-dashed border-gray-200">
                <span className="text-5xl block mb-4">📭</span>
                <p className="text-xs font-black text-gray-400 uppercase tracking-widest">
                  Belum ada riwayat cuti
                </p>
              </div>
            ) : (

              history.map((h) => (

                <div
                  key={h.id}
                  className="bg-white rounded-[28px] p-5 border border-gray-100 shadow-sm hover:shadow-md transition-all"
                >

                  {/* HEADER *//*}
                  <div className="flex justify-between items-start mb-4">

                    <div>
                      <p className="text-sm font-black text-gray-800">
                        {h.leave_type_name}
                      </p>

                      <p className="text-[11px] text-gray-400 font-bold mt-1">
                        {formatDate(h.date_from)} — {formatDate(h.date_to)}
                      </p>

                    </div>

                    {statusBadge(h.state)}

                  </div>


                  {/* META INFO *//*}
                  <div className="grid grid-cols-3 gap-3 mb-4">

                    <div className="bg-gray-50 rounded-xl p-3">
                      <p className="text-[9px] text-gray-400 font-black uppercase">
                        Durasi
                      </p>
                      <p className="text-sm font-black text-gray-800">
                        {h.number_of_days} Hari
                      </p>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-3">
                      <p className="text-[9px] text-gray-400 font-black uppercase">
                        Status
                      </p>
                      <p className="text-xs font-black text-gray-700 uppercase">
                        {h.state}
                      </p>
                    </div>

                    <div className="bg-gray-50 rounded-xl p-3">
                      <p className="text-[9px] text-gray-400 font-black uppercase">
                        Disetujui Oleh
                      </p>
                      <p className="text-xs font-black text-gray-700 truncate">
                        {h.approved_by || "-"}
                      </p>
                    </div>

                  </div>


                  {/* REASON *//*}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">

                    <p className="text-[10px] text-gray-400 font-black uppercase mb-1">
                      Alasan
                    </p>

                    <p className="text-[12px] text-gray-600 font-medium italic">
                      {h.reason}
                    </p>

                    {h.refuse_reason && (
                      <div className="mt-3 pt-3 border-t border-red-100">

                        <p className="text-[10px] text-red-400 font-black uppercase mb-1">
                          Alasan Penolakan
                        </p>

                        <p className="text-[11px] text-red-500 font-semibold">
                          {h.refuse_reason}
                        </p>

                      </div>
                    )}

                  </div>


                  {/* FOOTER *//*}
                  <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-100">

                    <p className="text-[9px] text-gray-400 font-bold uppercase">
                      ID #{h.id}
                    </p>

                    <p className="text-[9px] text-gray-300 font-bold uppercase">
                      HR System
                    </p>

                  </div>

                </div>

              ))

            )}

            <p className="text-center text-[9px] font-black text-gray-300 uppercase tracking-[0.3em] py-4">
              Redcrest HR System
            </p>

          </div>
        )}
      </div>

      {toast && (
        <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />
      )}
    </div>
  );
  */

  // ============================================================
  // Coming Soon Page
  // ============================================================
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col items-center justify-center px-6">
      <div className="text-center space-y-6 max-w-md">
        {/* Icon */}
        <div className="text-7xl animate-bounce">🚀</div>
        
        {/* Heading */}
        <div>
          <h1 className="text-3xl font-black text-gray-800 mb-2">
            Fitur Sedang Dikembangkan
          </h1>
          <p className="text-gray-500 text-sm">
            Manajemen Cuti akan segera hadir dengan fitur lengkap untuk memudahkan Anda mengelola cuti
          </p>
        </div>

        {/* Features Preview */}
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-3">
          <p className="text-xs font-black text-gray-400 uppercase tracking-widest mb-4">
            Fitur yang akan datang:
          </p>
          <div className="space-y-2 text-left">
            <div className="flex items-center gap-3">
              <span className="text-lg">📊</span>
              <span className="text-sm text-gray-600">Lihat sisa saldo cuti Anda</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg">📝</span>
              <span className="text-sm text-gray-600">Ajukan permohonan cuti dengan mudah</span>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-lg">📋</span>
              <span className="text-sm text-gray-600">Pantau riwayat pengajuan cuti Anda</span>
            </div>
          </div>
        </div>

        {/* Info */}
        <p className="text-xs text-gray-400 font-medium">
          Terima kasih atas kesabaran Anda 🙏
        </p>
      </div>
    </div>
  );
}
